import { Component, DoCheck, ElementRef, Input, KeyValueDiffers, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SmmPostService } from '../../_services/smm-post.service';
import { SmmService } from '../../_services/smm.service';
import { DashboardFilterService } from 'app/views/dashboards/dashboard-filter/dashboard-filter.service';
import { Subscription } from 'rxjs';

const Highcharts = require('highcharts');

@Component({
  selector: 'app-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss']
})
export class LineChartComponent implements DoCheck {
  // Modal
  modalRef: BsModalRef;
  public config = {
    keyboard: false,
    class: 'modal-lg'
  };

  @ViewChild('baseLineChart') baseLineChart: BaseChartDirective;
  @Input() dateInput: any;
  @Input() displayDateInput: string;
  @Input() searchKeyword: string;
  @Input() typesMapArray: Array<any>;
  @Input() typeNames: Array<any>;
  @Input() chartTitle: string;
  @Input() dataEmpty: boolean;
  @Input() project: Array<string>;
  @Input() projectName: string;


  // Filter
  public filterChart: any;
  // Sub
  subscription: Subscription;

  // Spin
  public isLoading = true;
  public errorMsg = "";

  public selectID = '1d';
  public timeUnit = '1d';
  public moment = require('moment');
  public countSeries: Array<any>;

  public timeUnitMenu: Array<any> = [
    // {id: '1h', label: '1 Giờ', active: true},
    // {id: '3h', label: '3 Giờ', active: false},
    // {id: '6h', label: '6 Giờ', active: false},
    // {id: '12h', label: '12 Giờ', active: false},
    { id: '1d', label: '1 Ngày', active: true }
    // ,{id: '1w', label: '1 Tuần', active: false}
  ];

  public lineChartLabels = [];
  public lineChartType = 'line';
  public lineChartLegend = true;
  public lineChartData: Array<any>;
  public lineChartOptions = {
    // scaleShowVerticalLines: true,
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      mode: 'index',
      intersect: false,
      position: 'nearest',
    },
    
    scales: {
      xAxes: [{
        stacked: true,
        scaleLabel: {
          stacked: true,
          display: false,
          labelString: ''
        },
        ticks: {
          fontColor: '#0099ff'
        }   
      }],
      yAxes: [{
        id: 'A',
        scaleLabel: {
          display: true,
          labelString: '',
        },
        ticks: {
          fontColor: '#0099ff'
        }
      }]
    },
    legend: {
      display: true,
      labels: {
        usePointStyle: true,
        fontSize: 12,
        fontColor: '#0099ff'
      }
    }
  };

  public lineChartColours: Array<any> = [
    { // Series B
      backgroundColor: 'transparent',
      borderColor: '#1877f2',
      borderWidth: 2,
      pointBackgroundColor: '#1877f2',
      pointBorderColor: '#fff',
      pointBorderWidth: 2,
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)'
    }
  ];
  differ: any;
  public chartOptions: any;

  @ViewChild('lineChartDiv') lineChartDiv: ElementRef;

  // DỮ LIỆU HIỂN THỊ LÊN POPUP
  public posts: Array<any> = [];
  public pages: Map<string, any> = new Map<string, any>();
  public groups: Map<string, any> = new Map<string, any>();
  public currentPosts = [];
  public titleModel: string;
  public sentimentPost: string;

  constructor(private differs: KeyValueDiffers
    , private toastrService: ToastrService
    , private modalService: BsModalService
    , private smmPostService: SmmPostService
    , private smmService: SmmService
    , private dashboardFilterService: DashboardFilterService) {
    this.differ = differs.find([]).create(null);
    this.subscription = this.dashboardFilterService.getData().subscribe(filter => {
      this.filterChart = filter;
    });
  }

  ngDoCheck() {
    const change = this.differ.diff(this.typesMapArray);
    if (change !== null) {
      this.updateChart();
    }
  }

  updateChart() {
    this.createChart();
    if (this.baseLineChart) {
      this.baseLineChart.chart.config.data.labels = this.lineChartLabels;
      this.baseLineChart.chart.update();
    }
  }

  public timeUnitChange(event, unit) {
    for (const timeUnit of this.timeUnitMenu) {
      this.timeUnit = unit;
      timeUnit.active = timeUnit.id === unit;
    }
    this.updateChart();
  }

  public createChart() {
    const timeSeries = [];
    this.lineChartData = [];
    this.lineChartLabels = [];
    this.countSeries = [];

    let interval = 1;
    if (this.timeUnit === '1h') {
      interval = 1;
    } else if (this.timeUnit === '3h') {
      interval = 3;
    } else if (this.timeUnit === '6h') {
      interval = 6;
    } else if (this.timeUnit === '12h') {
      interval = 12;
    } else if (this.timeUnit === '1d') {
      interval = 24;
    } else if (this.timeUnit === '1w') {
      interval = 24 * 7;
    }

    for (const temp of this.typesMapArray) {
      this.countSeries.push([]);
    }
    let temp_time = '';
    // let totalPos = 0;    
    const posSums = [];
    for (let time = this.dateInput.start; time <= this.dateInput.end; time += 3600 * 1000 * interval) {
      let posSum = 0;
      if (this.timeUnit === '1h') {
        temp_time = this.moment(time).format('DD/MM HH:mm');
      } else if (this.timeUnit === '3h') {
        temp_time = this.moment(time).format('DD/MM HH:mm');
      } else if (this.timeUnit === '6h') {
        temp_time = this.moment(time).format('DD/MM HH:mm');
      } else if (this.timeUnit === '12h') {
        temp_time = this.moment(time).format('DD/MM HH:mm');
      } else if (this.timeUnit === '1d') {
        temp_time = this.moment(time).format('DD/MM/YYYY');
      } else if (this.timeUnit === '1w') {
        temp_time = this.moment(time).format('DD/MM');
      }
      this.lineChartLabels.push(temp_time);
      timeSeries.push(time);
      let typeIndex = 0;
      for (const typeMap of this.typesMapArray) {
        let sum1 = 0;
        for (let i = 0; i < interval; i++) {
          const tempTime = time + i * 3600 * 1000;
          if (typeMap.has(tempTime)) {
            sum1 += typeMap.get(tempTime)[0];
            // totalPos += typeMap.get(tempTime)[0];            
            posSum += typeMap.get(tempTime)[0];
          }
        }
        this.countSeries[typeIndex].push(sum1);
        typeIndex++;
      }
      const momentTime = this.moment(time);
      const utcTime = Date.UTC(momentTime.year(), momentTime.month(), momentTime.date(), momentTime.hours(), 0, 0, 0);
      posSums.push([utcTime, posSum]);
    }

    const pivot = [];
    let index = 0;
    for (let time = this.dateInput.start; time <= this.dateInput.end; time += 3600 * 1000 * interval) {
      let tmpSum = 0;
      for (const type of this.countSeries) {
        tmpSum += type[index];
      }
      pivot.push(tmpSum);
      index++;
    }

    this.lineChartData.push({
      data: pivot, label: this.typeNames[0]
    });


  }

  public capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  /* ============================================= CHART EVENT - START ============================================= */
  public chartClicked(e: any, template): void {
    console.log(e);
    console.log(this.project);
    if (e.active.length > 0) {
      let active = e.active[0];
      let _index = active._index;
      let _xScale = active._xScale;
      let ticks = _xScale.ticks;
      let date = ticks[_index];

      // alert(this.formatDate(date, 0));
      // alert(this.formatDate(date, 1));

      this.titleModel = "Danh sách bài viết ngày " + date;
      let from = 0;
      let size = 20;
      let gte = this.formatDate(date, 0);
      let lte = this.formatDate(date, 1);
      // let projectIds = this.filterChart.projectSelectedIds;
      let projectIds = this.project;
      let provinces = this.filterChart.provinces;
      this.filterChart.projectSelectedIds = this.project;


      this.posts = [];
      this.currentPosts = [];
      let sentiment = [];

      // Modal
      this.modalRef = this.modalService.show(template, this.config);
      $(".modal-content").css({
        "background": "#7a2d2e",
        "opacity": "1",
        "color": "#FFFFFF"
      });

      // API Backend
      this.searchPosts(from, size, projectIds, lte, gte, sentiment, this.posts, this.pages, this.groups, provinces);
    }
  }

  public formatDate(strDate, number) {
    let time = 0;
    let arr = strDate.split("/");
    let day = "";
    if(parseInt(arr[0]) > 9){
      day = "" + (parseInt(arr[0]) + number);
    }else {
      day = "0" + (parseInt(arr[0]) + number);
    }
    let month = arr[1];
    let year = arr[2];
    let arrivalTime = year + "-" + month + "-" + day + "T00:00:00+07:00";
    var d = new Date(arrivalTime);
    return d.getTime();
  }

  public chartHovered(e: any): void {
    console.log(e);
  }
  /* ============================================= CHART EVENT - END ============================================= */

  /*======================================= CALL API BACKEND - START =======================================*/
  public searchPosts(from, size, projectIds, lte, gte, sentiment, posts, pages, groups, provinces) {
    this.smmPostService.searchDetailDiscussion({
      from: from,
      size: size,
      filter: {
        lte: lte,
        gte: gte,
        docTypes: ['user_post', 'page_post', 'group_post', 'news_article', 'news_blog', 'news_forum'],
        sentiment: sentiment,
        projectIds: projectIds,
        provinces: provinces,
        typeChart: 'line-chart'
      }
    }).subscribe(response => {
      // this.showError = false;
      if (response.success) {
        this.isLoading = false;

        if (response.data.hits.total.value > 0) {
          this.currentPosts = [];
          const pageIdArray = [];
          const groupIdArray = [];
          const userIdArray = [];

          for (const post of response.data.hits.hits) {
            post.showContent = false;

            // TMHIEP - 14/05/2020 - START
            post['_source']['sentiment'] = "";
            post['_source']['sentimentCode'] = "";
            let sentimentArray = [];
            if (post['_source']['topicSentiment'] !== undefined) {
              sentimentArray = post['_source']['topicSentiment'];
              for (let index = 0; index < sentimentArray.length; index++) {
                const element = sentimentArray[index];
                if (element.id == projectIds[0].toString()) {
                  let sentiment = element.sentiment;
                  if (sentiment == 'neu') {
                    post['_source']['sentiment'] = "Trung tính";
                    post['_source']['sentimentCode'] = "neu";
                  } else if (sentiment == 'pos') {
                    post['_source']['sentiment'] = "Tích cực";
                    post['_source']['sentimentCode'] = "pos";
                  } else if (sentiment == 'neg') {
                    post['_source']['sentiment'] = "Tiêu cực";
                    post['_source']['sentimentCode'] = "neg";
                  }
                  break;
                }
              }
            }
            // TMHIEP - 14/05/2020 - END

            // TMHIEP - 12/08/2020 - START - BÁO
            post['_source']['docTypeName'] = "";
            if (post['_source']['docType'] == "news_article") {
              post['_source']['docTypeName'] = "Báo chí";
              post['_source']['message'] = post['_source']['content'];
            } else if (post['_source']['docType'] == "news_blog") {
              post['_source']['docTypeName'] = "Blog";
              post['_source']['message'] = post['_source']['content'];
            } else if (post['_source']['docType'] == "news_forum") {
              post['_source']['docTypeName'] = "Forum";
              post['_source']['message'] = post['_source']['content'];
            }
            // TMHIEP - 12/08/2020 - END

            posts.push(post);
            if (post['_source'].userId) {
              post['_source']['sourceId'] = post['_source'].userId;
            } else {
              post['_source']['sourceId'] = post['_source'].pageId;
            }

            // if (!pages.has(post['_source'].sourceId)) { 
            if (post['_source'].docType === 'page_post') {
              if (post['_source'].sourceId !== undefined && pageIdArray.indexOf(post['_source'].sourceId) === -1) {
                pageIdArray.push(post['_source'].sourceId);
              }
            } else if (post['_source'].docType === 'user_post' || post['_source'].docType === 'group_post') {
              if (post['_source'].sourceId != null && userIdArray.indexOf(post['_source'].sourceId) === -1) {
                userIdArray.push(post['_source'].sourceId);
              }
              if (post['_source'].groupId !== undefined) {
                if (groupIdArray.indexOf(post['_source'].groupId) === -1) {
                  groupIdArray.push(post['_source'].groupId);
                } else {
                  // alert(JSON.stringify(groupIdArray));
                  // alert('hiep:    ' + post['_source'].groupId);
                }
              } else {
                // alert('undefined rồiiii');
              }
            }
            // }else{
            //   // alert(JSON.stringify(pages));
            //   // alert(post['_source'].sourceId);
            // }
          }

          if (pageIdArray.length > 0) {
            // console.log("=================pageIdArray===========");
            // console.log(pageIdArray);
            this.smmService.getPagesByIds(pageIdArray).subscribe(response1 => {
              const docs = response1.data.docs;
              for (const doc of docs) {
                if (doc['found']) {
                  pages.set(doc['_id'], doc['_source']);
                } else {
                  pages.set(doc['_id'], null);
                }
              }
            });
          }
          if (groupIdArray.length > 0) {
            // alert(groupIdArray.length);
            // console.log("=================groupIdArray===========");
            // console.log(groupIdArray);
            this.smmService.getGroupsByIds(groupIdArray).subscribe(response1 => {
              const docs = response1.data.docs;
              for (const doc of docs) {
                if (doc['found']) {
                  // console.log("====group info====")
                  // console.log(doc['_source']);                 
                  groups.set(doc['_id'], doc['_source']);
                } else {
                  groups.set(doc['_id'], null);
                }
              }
            });
          }
          if (userIdArray.length > 0) {
            // console.log("=================userIdArray===========");
            // console.log(userIdArray);
            this.smmService.getUsersByIds(userIdArray).subscribe(response1 => {
              if (response1.data !== undefined && response1.data.docs !== undefined) {
                const docs = response1.data.docs;
                for (const doc of docs) {
                  if (doc['found']) {
                    pages.set(doc['_id'], doc['_source']);
                  } else {
                    pages.set(doc['_id'], null);
                  }
                }
              }

            });
          }          
          this.errorMsg = "";
          this.currentPosts = this.posts;
        } else {
          this.isLoading = false;
          this.currentPosts = [];
          this.errorMsg = 'Không tìm thấy dữ liệu!';
        }
      } else {
        this.isLoading = false;
        this.currentPosts = [];
        this.errorMsg = 'Có lỗi xảy ra! Không tìm thấy dữ liệu!';
      }
    }
    );
  }
  /*======================================= CALL API BACKEND - END =======================================*/

  // MODAL
  closeModal() {
    this.modalRef.hide();
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/line-chart/line-chart.component.ts